/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- 컨덕터 tsconfig(noUncheckedIndexedAccess) 에선 필요한 인덱스 단언. dev tsconfig 에선 불필요로 보여 경고만 난다 */
// [V2] 출고일정관리(MWMS) 도메인 모델 — 컨덕터 소유(2026-09-10 ⑤ 1-C ③). DS `mwms/DispatchScheduleShared.ts` 를 그대로 옮겼다(값 변경 0).
//   registry/ 에 두는 이유: 시임(dispatchParts.tsx)이 `./dispatchShared` 로 끌어가고 산출물엔 그 상대경로 그대로 동반 파일로 실린다.
//   3층 레이어링(기본 → 시나리오 → 당일예외)·순위 해소·기간 충돌 등 도메인 규칙의 단일 원천. dispatchStore·dispatchAdapters·
//   시임(registry/dispatchParts.tsx)이 소비한다. 핸드오프 산출물에는 동반 파일(dispatchShared.ts)로 그대로 실린다.
//   ⚠️ 이 파일은 컨덕터 경로(@/…)를 import 하지 않는다 — dev 레포에 그대로 놓여도 성립해야 한다.
// DispatchScheduleShared — 컨덕터 dispatch-schedule/model.ts 의 실 이식본(닮은꼴 재구현 아님).
//
// 출고일정관리(MWMS) 도메인 모델 — dispatch-scheduling-v7.html 프로토타입의 순수 로직 포팅.
// 규칙 근거: 출고일정관리-설계문서.md (운영일 23시 시작, 케파=일 총량, 3층 레이어링, 무한/제한, C+A 중복방어).
// 이 파일은 React 무관 순수 함수만 둔다 — 뷰는 DispatchOpsGrid/DispatchPriority/DispatchGlobalPriority.
//   컨덕터 원본과 동일(1:1) — pbo-core 는 noUncheckedIndexedAccess 라 인덱스 접근에 ! / ?. / ?? 가드만 추가(로직 무변).
//   SOT 이관 후 컨덕터 model.ts 는 이 파일을 재노출하는 심(상대경로 소비자 무변).

export const CENTERS: [string, string][] = [
  ['신여주 1', 'YJU-01'], ['신여주 2', 'YJU-02'], ['신여주 3', 'YJU-03'], ['신여주 4', 'YJU-04'],
  ['동탄 1', 'DT-01'], ['동탄 2', 'DT-02'],
  ['곤지암', 'GJA-01'], ['용인', 'YIN-01'], ['이천', 'ICN-01'], ['김해', 'GHA-01'],
  ['대전', 'DJN-01'], ['청주', 'CJU-01'], ['광주', 'GWJ-01'],
]
export const N = CENTERS.length // 13

/** 케파 위험 임계(%) — 가동률이 이 값을 **넘으면** 위험으로 본다.
 *  ⚠️ 데모 임시값이다. 실제 구간(단계·기준·센터별 차등 여부)은 개발에서 정의해 내려준다(LUA 2026-09-16).
 *   그때 이 상수 하나만 갈아끼우면 되도록 값을 여기 한 곳에 둔다 — 화면·산출물이 같은 값을 본다. */
export const CAPA_RISK_PCT = 80

// ── 관리 단위(LUA 확정 2026-09-11) — 종전엔 '전체(국내 센터)' 하나였다. 타이틀 우측 세그먼티드로 고른다.
//  단위마다 **독립된 DispatchState** 를 갖는다(같은 인덱스 문법을 그대로 쓰려고 — 키에 단위를 섞지 않는다).
//  단위별 목록 길이가 달라도 상태가 분리돼 있어 cvBase·todayExc 등 ci 키가 겹치지 않는다.
export type DispatchUnit = 'center' | 'store' | 'global' | 'alloc'

/** 스토어 — 매장 출고(오프라인 스토어에서 직접 출고). 목 데이터.
 *  이름에 '무신사스토어' 를 붙인다(LUA 2026-09-28) — 할당 우선순위는 센터와 스토어를 **한 목록**에서 줄 세우므로
 *  이름만으로 어느 쪽인지 읽혀야 한다. 표에 구분 태그를 더하면 19행×24열 셀이 커진다(태그 대신 이름으로 가름). */
export const STORES: [string, string][] = [
  ['무신사스토어 홍대', 'ST-HD'], ['무신사스토어 성수', 'ST-SS'], ['무신사스토어 강남', 'ST-GN'],
  ['무신사스토어 한남', 'ST-HN'], ['무신사스토어 대구', 'ST-DG'], ['무신사스토어 부산', 'ST-BS'],
]

/** 글로벌센터 — 해외 출고 거점. 목 데이터(기존 화면 표기 '글로벌 센터(JP1)' 계열과 맞춤). */
export const GLOBAL_CENTERS: [string, string][] = [
  ['글로벌 센터(JP1)', 'JP-01'], ['글로벌 센터(JP2)', 'JP-02'],
  ['글로벌 센터(US1)', 'US-01'], ['글로벌 센터(CN1)', 'CN-01'],
]

export const UNITS: { key: DispatchUnit; label: string; list: [string, string][] }[] = [
  { key: 'center', label: '센터', list: CENTERS },
  { key: 'store', label: '스토어', list: STORES },
  { key: 'global', label: '글로벌센터', list: GLOBAL_CENTERS },
]

/** 단위 → 거점 목록. 모르는 값이면 센터(기본). */
export const unitList = (u: DispatchUnit): [string, string][] =>
  u === 'alloc' ? ALLOC_TARGETS : UNITS.find((x) => x.key === u)?.list ?? CENTERS

/* ── 할당 대상(LUA 2026-09-28) — 센터와 스토어를 **하나의 순위**로 줄 세운다.
 *  예: 1위 신여주 2 · 2위 무신사스토어 한남 · 3위 신여주 1. 주문이 갈 곳을 고르는 한 판단이라 단위를 가르지 않는다
 *  (단위를 가르면 '센터 1위'와 '스토어 1위' 둘이 생겨 어디로 보낼지 화면이 답하지 못한다).
 *  케파·업무시간은 반대다 — 그건 거점 종류마다 기준이 달라 출고일정관리가 단위(센터/스토어/글로벌)로 나눠 관리한다.
 *  그래서 이 목록은 UNITS(세그먼티드 선택지)에 넣지 않는다 — 고르는 값이 아니라 할당우선순위 화면의 고정 축이다.
 *  인덱스 = 센터 13 + 스토어 6 = 19(앞이 센터). 글로벌 Top3 는 해외 출고 거점이라 센터만 본다(LUA 2026-09-28). ── */
export const ALLOC_TARGETS: [string, string][] = [...CENTERS, ...STORES]
export const ALLOC_N = ALLOC_TARGETS.length // 19
/** 할당 대상 인덱스가 스토어인가 — 매장 규모 케파 시드에 쓴다(앞 13이 센터). */
export const isAllocStore = (ci: number): boolean => ci >= CENTERS.length
/** 할당 목록 인덱스 → 스토어 목록 인덱스(STORES 기준). 같은 매장이 두 화면에서 같은 값을 갖게 하는 환산이다 —
 *  종전엔 할당 목록 인덱스(13~18)를 그대로 케파 시드에 넣어 출고일정관리(0~5)와 값이 갈렸다(2026-09-29 검토). */
export const allocStoreIdx = (ci: number): number => ci - CENTERS.length
/** 스토어 기본 케파(일) — 매장 출고는 센터 규모가 아니다. 목 데이터: 500~1,500건(100 단위). */
export function storeBaseCapa(si: number): number { return Math.round((500 + seed(si * 11 + 3) * 1000) / 100) * 100 }

// 운영일은 23시에 시작 → 표시 순서: 23, 00, 01, … 22 (00시 컬럼에 하루 경계)
export const HOURS_ORD = [23, ...Array.from({ length: 23 }, (_, i) => i)]
export const DOW7 = ['일', '월', '화', '수', '목', '금', '토']

// ── 주(week) 단위 — 그리드 날짜 창은 월요일 시작 캘린더 주(LUA, MWMS 위크 내비 기준) ──
export const weekStart = (d: Date) => { const x = new Date(d); x.setHours(0, 0, 0, 0); x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); return x }
// ISO-8601 주차(월요일 시작, 첫 목요일 포함 주 = W1) — MWMS 'W28' 표기와 동일 체계
export const isoWeek = (d: Date) => {
  const x = new Date(d); x.setHours(0, 0, 0, 0)
  x.setDate(x.getDate() + 3 - ((x.getDay() + 6) % 7)) // 그 주의 목요일
  const w1 = new Date(x.getFullYear(), 0, 4) // 1월 4일은 항상 W1
  return 1 + Math.round(((x.getTime() - w1.getTime()) / 86400000 - 3 + ((w1.getDay() + 6) % 7)) / 7)
}

// 결정적 의사난수 — 프로토타입과 동일(데모 시드값 재현)
export const seed = (s: number) => { const x = Math.sin(s) * 10000; return x - Math.floor(x) }

/* ── 날짜 유틸 (내부는 Date, 외부 표기는 YYYY-MM-DD) ── */
export function parseYmd(s: string): Date { const [y, m, d] = s.split('-').map(Number) as [number, number, number]; return new Date(y, m - 1, d) }
export function fmtYmd(d: Date): string { return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}` }
export function fmtMD(d: Date): string { return `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}` }
export function addDays(d: Date, n: number): Date { const x = new Date(d); x.setDate(x.getDate() + n); return x }
export function sameDay(a: Date, b: Date): boolean { return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate() }
export function dKey(d: Date): string { return fmtYmd(d) }

/** 시간대 편집 창(당일 예외 등록)의 머리 — 잠금·제목·닫기 문구. 데모 컨트롤러(openHour)와 산출물(PriorityTable 열 클릭)이 **같은 식**을 쓴다.
 *  잠금 = 오늘이 아닌 날 또는 지난 시간대(운영일은 23시 시작 — 23시는 00시보다 앞). 잠긴 창은 조회 전용이라 제목·닫기 문구가 바뀐다. */
export function hourModalHead(today: Date, dayOffset: number, nowHour: number, hr: number): { locked: boolean; title: string; cancelText: string; lockMsg: string } {
  const d = addDays(today, dayOffset)
  const isToday = sameDay(d, today)
  const isPastDay = !isToday && d < today
  const pos = hr === 23 ? -1 : hr
  const nowPos = nowHour === 23 ? -1 : nowHour
  const locked = !isToday || pos < nowPos
  const p2 = (n: number) => String(n).padStart(2, '0')
  const span = `${p2(hr)}:00 ~ ${p2((hr + 1) % 24)}:00`
  return {
    locked,
    title: locked ? `${span} (조회)` : `${span} 예외 등록`,
    cancelText: locked ? '닫기' : '취소',
    lockMsg: isPastDay ? '지난 날짜는 조회 전용입니다. 확정된 값입니다.' : !isToday ? '예외는 당일만 등록할 수 있습니다. 예정 날짜를 바꾸려면 해당 기간의 운영을 변경하세요.' : '지난 시간은 수정할 수 없습니다. 확정된 값입니다.',
  }
}
/** 운영(시나리오) 설정 창의 머리 — 편집이면 '<운영 전체명> 편집'·편집 표시(삭제·전체 초기화가 보인다), 신규면 '<단위>운영 추가'.
 *  데모 컨트롤러(openSettings('scen'))와 산출물(운영 카드 [수정]·[운영 추가])이 같은 식을 쓴다. */
export function scenModalHead(scenarios: Scenario[], id: string | null, unitLabel = ''): { title: string; editing: boolean; isNew: boolean } {
  const meta = id ? scenarios.find((sc) => sc.id === id) : undefined
  return { title: id ? `${meta?.full ?? '운영'} 편집` : `${unitLabel}운영 추가`, editing: !!id, isNew: !id }
}

/* ── 타입 ── */
export type CapaMode = 'limited' | 'unlimited'
// active — **센터 자체를 이 화면에서 관리하는가**(2026-09-16 LUA). 휴무(off)와 층이 다르다:
//  휴무는 '문 연 센터가 그날/그 요일 쉰다', active:false 는 '아직 안 열었거나 접은 센터라 표에 없다'.
//  기본 운영의 속성이라 운영(시나리오)별로는 바꾸지 않는다(ScenOverride 에 없다) — 운영은 '그 기간 어떻게
//  돌릴까' 를 정하는 것이지 센터의 존재를 정하는 게 아니다.
//  optional + `!== false` 판정 — 기존 저장값·시드에 이 키가 없어도 전부 '사용' 으로 읽힌다.
/** 일괄 출고 — **시각 목록**이다(LUA 확정 2026-09-18). 유형(당일배송/익일배송/기타) Select 은 걷었다:
 *  유형은 '그 시각이 무엇을 지키는가' 를 말할 뿐 값 자체가 아니고, 고르는 단계가 한 번 더 드는 만큼을
 *  화면이 돌려주지 못했다. 센터마다 취급이 다르다는 원래 문제는 **행 수**가 이미 표현한다 —
 *  두 번 내보내는 센터는 두 줄, 한 번만 내보내는 센터는 한 줄, 안 내보내는 날은 0줄.
 *  값은 'HH:mm'. 운영일이 자정을 넘으므로 '24:00' 도 유효값이다(ReleaseList 가 00:00 으로 보여주고 되돌린다). */
export type Release = string
/** 정렬 키 — 표기 그대로의 분. '24:00' = 1440 이라 22:00 다음에 온다(운영일 순서가 아니라 **보이는 순서**다.
 *  같은 셀의 '출고 시작 08:00' 도 시계 그대로 보여주므로 한 줄 안에서 읽는 규칙이 하나다). */
export const relMin = (at: string): number => {
  const [h = '0', m = '0'] = at.split(':')
  return Number(h) * 60 + Number(m)
}
/** 시각 순 정렬 + 중복 제거. 사용자 입력 순서가 아니다 — 센터끼리 세로로 비교하는 표라 줄이 흔들리면 안 된다. */
export const normRel = (list: Release[]): Release[] => [...new Set(list)].sort((a, b) => relMin(a) - relMin(b))
/** 저장용 — 정규화 + **빈 시각 제거**. 편집 중에는 방금 추가한 행이 비어 있으므로 normRel 은 지우지 않는다
 *  (지우면 행이 추가되자마자 사라진다). 거르는 건 저장 직전 한 번뿐이다. */
export const cleanRel = (list: Release[]): Release[] => normRel(list).filter((at) => !!at)
/** 상한 비교용 분 값 — **원시 분**(00:00~23:59). 자정('24:00'·'00:00')은 0분이라 어떤 종료보다도 이르다.
 *  BE 계약(00:00 은 22:00 이하)과 dev 결정(mwms-fe 2026-10-06 store-work-end-time 3번)을 따른다 — DEV 기본값
 *  '종료 22:00 + 일괄 22:00·00:00' 이 정상 데이터다. 정렬·표기(24:00 = 1440, 맨 뒤)는 relMin 그대로 — 검증 축과 표시 축을 나눈다(2026-10-13). */
const limitMin = (at: string): number => (at === '24:00' ? 0 : relMin(at))
/** 그 시각이 '출고 종료' 뒤인가 — 종료 이후에는 출고지시가 없으므로 일괄 출고도 있을 수 없다(LUA 2026-09-29).
 *  종료가 없으면 제한도 없다. 비교는 limitMin(원시 분) — 자정 일괄 출고는 종료보다 늦지 않다. */
export const relAfterEnd = (at: string, endAt?: string): boolean => !!endAt && !!at && limitMin(at) > limitMin(endAt)
export const sameRel = (a: Release[], b: Release[]): boolean => a.length === b.length && a.every((x, i) => x === b[i])
/** '22:00 · 24:00' — 힌트·잠김 조회·표 셀의 단일 표기. 빈 목록은 '없음'. */
export const relText = (list: Release[]): string => (list.length ? list.join(' · ') : '없음')

/** 출고 종료 — **이 시각 이후로는 출고지시를 받지 않는다**(LUA 확정 2026-09-29). 스토어 전용:
 *  매장은 영업시간이 있어 '더 이상 안 받는 시점'이 실재하고, 센터는 교대로 돌아 그 시점이 없다.
 *  '출고 시작'과 한 쌍(시작~종료 = 지시를 받는 창)이라 셀·폼에서 시작 바로 아래에 선다.
 *  ✗ '마감' — 운영이 이미 당일배송 마감(컷오프)으로 쓰고, 케파 소진도 '마감'이라 부른다(같은 화면에서 셋이 겹친다).
 *  ✗ '종료' 외 후보 '출고지시 마감' — 정확하지만 셀 안에 '출고 시작·일괄 출고·출고지시 마감' 셋이 서면 라벨이 길다.
 *  없으면(undefined) 종료 없이 계속 받는다. 값은 'HH:mm'(일괄 출고와 같은 시계 표기). */
export interface CenterVals { capa: number; capaMode: CapaMode; start: string; endAt?: string; releases: Release[]; restDays: number[]; active?: boolean }
// capaMode — 제한/무한은 **케파 값과 한 쌍**이다. 종전엔 DowCard 에만 빠져 있어 요일 예외로는
//  케파 숫자만 바꾸고 제한/무한은 못 바꿨다(센터 기본값 CenterVals·시나리오 ScenOverride 에는 있다. LUA 2026-09-15).
export interface DowCard { days: number[]; capa?: number; capaMode?: CapaMode; start?: string; endAt?: string; releases?: Release[] }
// 당일예외 — 기본값 카드와 동일 필드 세트(케파/출고시작/당일·익일 일괄 출고/휴무). 변경 사유는 제거(LUA, 선택 필드로 유지)
//  capaMode — DowCard 와 같은 누락이 여기에도 있었다(2026-09-17 LUA 지적). 케파 숫자만 바꿀 수 있고
//  제한/무한은 못 바꿔서, '오늘만 무한으로 열어둔다'(초과해도 출고지시 계속) 가 예외로 표현되지 않았다.
//  기본값 CenterVals · 시나리오 ScenOverride · 요일 DowCard 에는 전부 있다 — 당일예외만 빠져 있었다.
export interface ExcEntry { capa?: number; capaMode?: CapaMode; start?: string; endAt?: string; releases?: Release[]; off?: boolean; reason?: string; by: string; at: string }
export interface Scenario {
  id: string
  seq: number // 생성순 — 우선순위 '마지막 생성 우선' 규칙의 근거
  name: string; full: string; desc: string
  color: string // 팔레트 키: sum | par | chu | yju | c1..c4
  from: string; to: string // YYYY-MM-DD (inclusive)
  // ⚠ 규칙(LUA 확정 2026-07-09): 시나리오는 날짜 단위 배타 — 하루에 1개만. 기간 겹침은 저장 단계에서 차단.
  //   센터별 차등은 '적용 센터' 지정이 아니라 시나리오 안의 센터별 운영값(scenVals)으로 표현한다.
}
// 시나리오별 센터 운영값 오버라이드: scenVals[scenId][ci] = 부분 값(건드린 값만).
// 기본 운영과 동일한 편집 동작(LUA) — capaMode(제한/무한)·restDays(휴무 요일, '전체 교체' 의미)도 오버라이드 가능.
export type ScenVals = Record<string, Record<number, Partial<Pick<CenterVals, 'capa' | 'capaMode' | 'start' | 'endAt' | 'releases' | 'restDays'>>>>
// 시나리오별 요일 예외 카드: scenDow[scenId][ci] = 기본 운영의 dowExc 와 동일 구조(운영 기간 내에서만 적용)
export type ScenDow = Record<string, Record<number, DowCard[]>>
// 시나리오별 우선순위 오버라이드: scenPrio[scenId][hour] = order[](rank위치→센터index)
export type ScenPrio = Record<string, Record<number, number[]>>

export interface DispatchState {
  scenarios: Scenario[]
  scenVals: ScenVals
  scenPrio: ScenPrio
  todayExc: Record<string, ExcEntry> // key = `${ymd}|${ci}`
  prioEdits: Record<string, number[]> // key = `${ymd}|${hour}`
  scenDow: ScenDow // 시나리오별 요일 예외(기본 dowExc 와 동일 동작, 운영 기간 한정)
  basePrio: Record<number, number[]> // 기본 운영의 시간대별 순위 오버라이드 (기본운영 폼에서 편집)
  baseWait: Record<number, number> // 기본 운영의 시간대별 출고대기시간(분, 30분 단위) — 없으면 DEFAULT_WAIT
  // 글로벌 할당 우선순위(LUA 2026-07-13): 글로벌 주문을 받을 센터 Top 3(센터 인덱스, 순서=순위).
  // 규칙 — 기본값만 관리(운영 오버라이드·당일 예외 없음), 시간대 구분 없음, 출고대기시간은 일반 할당 우선순위를 그대로 따름.
  globalPrio: number[]
  scenWait: Record<string, Record<number, number>> // 운영별 출고대기시간 오버라이드 — 순위(scenPrio)와 동일 레이어링
  waitEdits: Record<string, number> // 당일 출고대기 예외 — key = `${ymd}|${hour}` (prioEdits 와 동일 문법, 운영 미반영)
  cvBase: Record<number, CenterVals>
  dowExc: Record<number, DowCard[]>
  // LOGISPRD-14424: 시간별 순위 구간 길이(order 의 앞 ranked 개만 순위, 나머지는 '순위 없음').
  //  레이어 키는 basePrio·scenPrio·prioEdits 와 같다. 없으면 전부 순위 구간(targets 없는 경로와 동일).
  basePrioRanked?: Record<number, number>
  scenPrioRanked?: Record<string, Record<number, number>>
  prioEditsRanked?: Record<string, number>
}

/* ── 데모 시드 (프로토타입과 동일 값) ── */
export const DEMO_SCENARIOS: Scenario[] = [
  { id: 'sum', seq: 1, name: '여름 블프', full: '2026 여름 블프 운영', desc: '케파 +30% · 마감 연장', color: 'sum', from: '2026-06-09', to: '2026-06-11' },
  { id: 'par', seq: 2, name: '택배파업', full: '택배파업 임시 운영', desc: '수도권 당일배송 중단', color: 'par', from: '2026-06-14', to: '2026-06-16' },
  { id: 'chu', seq: 3, name: '추석', full: '추석 주간 운영', desc: '일부 센터 휴무', color: 'chu', from: '2026-09-14', to: '2026-09-18' },
  { id: 'yju', seq: 4, name: '신여주 증설', full: '신여주 증설 테스트', desc: '신여주 1~4 케파 +50%', color: 'yju', from: '2026-06-12', to: '2026-06-13' },
]
// ── 단위별 운영 시나리오(LUA 2026-09-11) — 단위마다 운영 성격이 다르다.
//  규칙은 동일: 하루 1개(기간 겹침 금지) · 센터별 차등은 scenVals 로 표현.
//  색은 SCEN_ANTD_COLOR 팔레트 키를 단위 안에서 겹치지 않게 배정한다.

/** 스토어 — 매장 출고. 행사·리뉴얼처럼 **매장 단위 사건**이 운영을 바꾼다. */
export const STORE_SCENARIOS: Scenario[] = [
  { id: 'stSale', seq: 1, name: '시즌오프', full: '2026 여름 시즌오프', desc: '전 매장 케파 +40% · 마감 연장', color: 'sum', from: '2026-06-05', to: '2026-06-08' },
  { id: 'stPop', seq: 2, name: '성수 팝업', full: '성수 팝업스토어 기간', desc: '성수 케파 2배', color: 'yju', from: '2026-06-10', to: '2026-06-12' },
  { id: 'stRnv', seq: 3, name: '홍대 리뉴얼', full: '홍대 매장 리뉴얼 휴점', desc: '홍대 전 요일 휴무', color: 'par', from: '2026-06-17', to: '2026-06-19' },
  { id: 'stChu', seq: 4, name: '추석 단축', full: '추석 연휴 단축 운영', desc: '전 매장 당일마감 중단', color: 'chu', from: '2026-09-14', to: '2026-09-18' },
]

/** 글로벌센터 — 해외 출고. **현지 시즌·연휴**가 운영을 바꾼다. */
export const GLOBAL_SCENARIOS: Scenario[] = [
  { id: 'glSummer', seq: 1, name: '서머세일', full: '글로벌 서머세일', desc: '전 센터 케파 +50% · 익일마감 연장', color: 'sum', from: '2026-06-09', to: '2026-06-13' },
  { id: 'glObon', seq: 2, name: '오본 휴무', full: '일본 오본 연휴', desc: 'JP1·JP2 휴무', color: 'chu', from: '2026-08-13', to: '2026-08-16' },
  { id: 'glSing', seq: 3, name: '광군제', full: '중국 광군제(11.11)', desc: 'CN1 케파 2배', color: 'yju', from: '2026-11-10', to: '2026-11-12' },
  { id: 'glBf', seq: 4, name: '블랙프라이데이', full: '미국 블랙프라이데이', desc: 'US1 케파 2배', color: 'par', from: '2026-11-27', to: '2026-11-29' },
]

/** 단위 → 운영 시나리오 목록. */
export const unitScenarios = (u: DispatchUnit): Scenario[] =>
  u === 'store' ? STORE_SCENARIOS : u === 'global' ? GLOBAL_SCENARIOS : DEMO_SCENARIOS

// 신규 시나리오에 배정할 추가 색상 슬롯 (Ant 기능색 계열)
export const EXTRA_COLORS = ['c1', 'c2', 'c3', 'c4']
// 팔레트 키 → antd Tag 프리셋 컬러 (figma-tokens Base 팔레트와 1:1 — 태그는 antd Tag 로 렌더)
export const SCEN_ANTD_COLOR: Record<string, string> = {
  sum: 'orange', par: 'green', chu: 'blue', yju: 'purple', c1: 'magenta', c2: 'cyan', c3: 'gold', c4: 'geekblue',
}

export function defaultBase(ci: number): CenterVals {
  return {
    capa: Math.round((8000 + seed(ci * 7 + 1) * 6000) / 1000) * 1000,
    capaMode: ci === 4 || ci === 9 ? 'unlimited' : 'limited', // 데모: 동탄1·김해 무한
    start: '08:00', releases: ['22:00', '24:00'], restDays: [], active: true,
  }
}
/** 이 센터를 관리 대상으로 쓰는가 — 표에 줄을 낼지 정하는 단일 판정(한 군데서 정의해 화면·산출물이 같은 것을 본다). */
export function isCenterActive(state: DispatchState, ci: number): boolean { return getBase(state, ci).active !== false }
export function getBase(state: DispatchState, ci: number): CenterVals { return state.cvBase[ci] ?? defaultBase(ci) }

/* ── 시나리오 매칭 — 하루 1개 규칙이라 날짜로 유일하게 결정 ── */
export function scenWithin(s: Scenario, d: Date): boolean { return d >= parseYmd(s.from) && d <= parseYmd(s.to) }
// 그 날짜에 적용 중인 시나리오 (겹침이 차단되므로 최대 1개 — 첫 매칭)
export function scenOf(scenarios: Scenario[], d: Date): Scenario | null {
  return scenarios.find((s) => scenWithin(s, d)) ?? null
}
// 기간 중복 검사: 주어진 기간과 하루라도 겹치는 '다른' 시나리오 목록 (있으면 저장 불가)
export function periodConflicts(scenarios: Scenario[], editingId: string | null, period: { from: Date; to: Date } | null): Scenario[] {
  if (!period) return []
  return scenarios.filter((s) => s.id !== editingId && period.from <= parseYmd(s.to) && period.to >= parseYmd(s.from))
}
// "YYYY-MM-DD ~ YYYY-MM-DD" 파싱 (A안 저장 검증에서도 사용)
export function parsePeriod(str: string): { from: Date; to: Date } | null {
  const m = str.split('~').map((s) => s.trim())
  if (m.length !== 2) return null
  if (!/^\d{4}-\d{2}-\d{2}$/.test(m[0]!) || !/^\d{4}-\d{2}-\d{2}$/.test(m[1]!)) return null
  const f = parseYmd(m[0]!); const t = parseYmd(m[1]!)
  if (Number.isNaN(f.getTime()) || Number.isNaN(t.getTime()) || f > t) return null
  return { from: f, to: t }
}

/* ── 우선순위 ── */
// 시간별 결정적 기본 순열 (1~13위, 중복 없음)
// n = 줄 세울 거점 수(기본 = 센터 13). 할당우선순위는 센터+스토어 19를 함께 세운다 — 길이가 안 맞으면
//  표가 13행만 그려 스토어가 사라진다(2026-09-28).
export function permFor(h: number, n: number = N): number[] {
  const arr = Array.from({ length: n }, (_, i) => ({ i, k: seed(i * 13.7 + h * 4.3) }))
  arr.sort((a, b) => a.k - b.k)
  return arr.map((o) => o.i)
}
export function ranksForHour(h: number, n: number = N): { rankByCenter: number[]; order: number[] } {
  const order = permFor(h, n)
  const rankByCenter = new Array<number>(n)
  order.forEach((ci, pos) => { rankByCenter[ci] = pos + 1 })
  return { rankByCenter, order }
}
/* 할당 대상(센터+스토어) 기본 순열 — 목데이터 규칙: 스토어는 **대체로 뒤쪽**에 오도록 키에 편향을 준다.
 *  왜: 완전 무작위로 섞으면 상위 5칸이 매장으로만 차기도 한다(2026-09-28 실측). 매장은 재고·처리량이 센터보다
 *  작아 기본 순위가 센터보다 뒤인 게 운영 상식이고, 그래도 사이사이 끼어야 한다(예: 2위 무신사스토어 한남).
 *  0.35 = 순열 키(0~1) 대비 중간 편향 — 스토어가 상위권에 못 오는 것도, 상·하위가 갈리는 것도 아닌 정도. */
export const ALLOC_STORE_BIAS = 0.35
export function allocPermFor(h: number): number[] {
  const arr = ALLOC_TARGETS.map((_, i) => ({ i, k: seed(i * 13.7 + h * 4.3) + (isAllocStore(i) ? ALLOC_STORE_BIAS : 0) }))
  arr.sort((a, b) => a.k - b.k)
  return arr.map((o) => o.i)
}
export function allocRanksForHour(h: number): { rankByCenter: number[]; order: number[] } {
  const order = allocPermFor(h)
  const rankByCenter = new Array<number>(ALLOC_N)
  order.forEach((ci, pos) => { rankByCenter[ci] = pos + 1 })
  return { rankByCenter, order }
}
// 순위 해소: ①운영자 수동 편집 → ②그 날짜에 걸린 시나리오 중 '가장 마지막 생성(seq 큰)' 오버라이드 → ③기본
/** 그 단위의 기본 순열 — 순위 시드가 없을 때의 폴백. 길이가 거점 수와 달라지면 표가 그만큼만 그려져
 *  거점이 사라진다(할당우선순위 = 센터 13 + 스토어 6). 폴백 자리마다 길이를 따로 계산하지 않게 한 곳에 둔다. */
export function baseOrderFor(hr: number, unit: DispatchUnit = 'center'): number[] {
  return unit === 'alloc' ? allocPermFor(hr) : permFor(hr, unitList(unit).length)
}
export function orderFor(state: DispatchState, d: Date, hr: number, unit: DispatchUnit = 'center'): number[] {
  const k = `${dKey(d)}|${hr}`
  if (state.prioEdits[k]) return state.prioEdits[k]!
  const hit = state.scenarios
    .filter((s) => scenWithin(s, d) && state.scenPrio[s.id] && state.scenPrio[s.id]?.[hr])
    .sort((a, b) => b.seq - a.seq)
  if (hit.length) return state.scenPrio[hit[0]!.id]![hr]!
  return state.basePrio[hr] ?? baseOrderFor(hr, unit)
}
/** LOGISPRD-14424: orderFor 와 같은 레이어로 그 시간의 순위 구간 길이를 해소한다. 선택된 레이어에 값이 없으면 undefined(= 전부 순위). */
export function rankedFor(state: DispatchState, d: Date, hr: number): number | undefined {
  const k = `${dKey(d)}|${hr}`
  if (state.prioEdits[k]) return state.prioEditsRanked?.[k]
  const hit = state.scenarios
    .filter((s) => scenWithin(s, d) && state.scenPrio[s.id] && state.scenPrio[s.id]?.[hr])
    .sort((a, b) => b.seq - a.seq)
  if (hit.length) return state.scenPrioRanked?.[hit[0]!.id]?.[hr]
  return state.basePrio[hr] ? state.basePrioRanked?.[hr] : undefined
}
/* ── 출고대기시간(LUA 2026-07-13): 주문 접수 후 센터 할당까지의 대기 시간(분, 30분 단위·최대 9시간).
 * 예: 11~12시 출고대기시간 60분이면 11:15 주문은 12:15에 할당. 0 = 즉시 할당.
 * 해소: 당일 예외(waitEdits) → 그 날짜에 걸린 운영 중 마지막 생성(seq) 오버라이드 → 기본 운영(baseWait) → DEFAULT_WAIT. ── */
export const DEFAULT_WAIT = 0
// 출고대기시간 상한 — 30분 단위, 최대 9시간(LUA). 입력 UI 는 선택형(WaitSelect)만 사용(프리텍스트 금지)
export const WAIT_MAX = 540
export function waitFor(state: DispatchState, d: Date, hr: number): number {
  const k = `${dKey(d)}|${hr}`
  if (state.waitEdits[k] != null) return state.waitEdits[k]! // 당일 예외 — 우선순위 수동 편집과 동일한 최상위 레이어
  const hit = state.scenarios
    .filter((s) => scenWithin(s, d) && state.scenWait[s.id] && state.scenWait[s.id]?.[hr] != null)
    .sort((a, b) => b.seq - a.seq)
  if (hit.length) return state.scenWait[hit[0]!.id]![hr]!
  return state.baseWait[hr] ?? DEFAULT_WAIT
}
export function fmtWait(m: number): string {
  if (m <= 0) return '즉시'
  if (m < 60) return `${m}분`
  return m % 60 === 0 ? `${m / 60}시간` : `${Math.floor(m / 60)}시간 ${m % 60}분`
}

/** 시간대 창을 열 때의 값 — 머리(hourModalHead) + 이 시간대의 순위·출고대기와 '기준값(당일 예외를 뺀 값)과 같은가'.
 *  [초기화]는 기준값과 같으면 꺼진다(allIsBase). 데모 컨트롤러(openHour)와 산출물(열 클릭)이 같은 식을 쓴다 — 산출물은 DISPATCH_STATE(조회 결과 자리)로 부른다. */
export function hourModalSeed(state: DispatchState, today: Date, dayOffset: number, nowHour: number, hr: number, unit: DispatchUnit = 'center') {
  const d = addDays(today, dayOffset)
  const key = `${dKey(d)}|${hr}`
  const same = (a: number[], b: number[]) => a.length === b.length && a.every((x, i) => x === b[i])
  const order = orderFor(state, d, hr, unit)
  const pe = { ...state.prioEdits }; delete pe[key]
  const orderBase = orderFor({ ...state, prioEdits: pe }, d, hr, unit)
  const orderPrev = orderFor(state, d, (hr + 23) % 24, unit).slice()
  // LOGISPRD-14424: 순위 구간 길이 — 값이 있을 때만 폼에 싣는다(targets 없는 경로의 폼 모양 무변경).
  const ranked = rankedFor(state, d, hr)
  const rankedBase = rankedFor({ ...state, prioEdits: pe }, d, hr)
  const rankedPrev = rankedFor(state, d, (hr + 23) % 24)
  const prioSame = same(order, orderBase) && ranked === rankedBase
  const wait = waitFor(state, d, hr)
  const we = { ...state.waitEdits }; delete we[key]
  const waitBase = waitFor({ ...state, waitEdits: we }, d, hr)
  return {
    key, d, orderBase, orderPrev, waitBase, rankedBase, rankedPrev,
    values: {
      ...hourModalHead(today, dayOffset, nowHour, hr),
      order,
      ...(ranked !== undefined ? { ranked } : {}),
      prioIsBase: prioSame,
      allIsBase: prioSame && wait === waitBase,
      wait,
      waitText: fmtWait(wait),
      waitIsBase: wait === waitBase,
      waitExc: wait !== waitBase,
      changed: false,
      // 적용 범위 — 기본은 이 시간대만. 범위를 넓히는 건 사용자가 의식적으로 고르는 일이다.
      scope: 'one',
      scopeHint: '',
    },
  }
}

// 그 날짜·시간에 우선순위를 적용 중인 시나리오 (표시용, 수동 편집이 있으면 null)
export function activeScenPrioFor(state: DispatchState, d: Date, hr: number): Scenario | null {
  if (state.prioEdits[`${dKey(d)}|${hr}`]) return null
  const hit = state.scenarios
    .filter((s) => scenWithin(s, d) && state.scenPrio[s.id] && state.scenPrio[s.id]?.[hr])
    .sort((a, b) => b.seq - a.seq)
  return hit.length ? hit[0]! : null
}

/* ── 셀 값 3층 레이어링: 기본(+요일예외·정기휴무) → 시나리오 → 당일예외 ── */
export function excKey(ci: number, d: Date): string { return `${dKey(d)}|${ci}` }
export type ChgSrc = '시나리오' | '당일예외' | undefined
export interface CellVals {
  capa: number; capaMode: CapaMode; start: string; endAt?: string; releases: Release[]
  off?: boolean; util?: number; orders?: number; orderPct?: number
  scen: Scenario | null; exc?: ExcEntry
  // samedayDir 은 어디서도 읽지 않는 죽은 필드였다 — 목록으로 바꾸며 걷었다(capaDir 도 읽는 곳이 없다. 별도 정리).
  chg: { capa?: ChgSrc; capaDir?: 'up' | 'down'; releases?: ChgSrc; start?: ChgSrc; endAt?: ChgSrc }
}
export function dayVals(state: DispatchState, today: Date, d: Date, ci: number): CellVals {
  const b = getBase(state, ci)
  const v: CellVals = { capa: b.capa, capaMode: b.capaMode, start: b.start, endAt: b.endAt, releases: b.releases, scen: null, chg: {} }
  // 기본 레벨: 정기 휴무 요일 + 요일 예외 카드(설정된 값만 덮음 — 기본과 같은 위계라 변경 표시는 안 함)
  if (b.restDays.includes(d.getDay())) v.off = true
  const card = (state.dowExc[ci] ?? []).find((c) => c.days.includes(d.getDay()))
  if (card) {
    if (card.capa != null) v.capa = card.capa
    if (card.capaMode) v.capaMode = card.capaMode
    if (card.start) v.start = card.start
    if (card.endAt) v.endAt = card.endAt
    // 일괄 출고는 **목록 전체 교체**다(LUA 확정 2026-09-18) — 휴무 요일(restDays)과 같은 규칙.
    //  유형별 덮어쓰기가 아니라 통째 대체라, '그 날은 당일배송 일괄 출고 없음' 을 **행을 빼는 것**으로 표현한다.
    //  종전 모델의 sameday='중단' 특수값이 여기로 흡수됐다.
    if (card.releases) v.releases = card.releases
  }
  // 시나리오 레벨 — 날짜 단위 적용(하루 1개). 데모 4종의 값 조정도 실제 scenVals 데이터(시드)로 표현
  // (렌더 하드코딩 제거 — '기존 운영 설정 불러오기'가 데모에서도 실데이터를 복사하게, LUA).
  const st = scenOf(state.scenarios, d)
  v.scen = st
  if (st) {
    const ov = state.scenVals[st.id]?.[ci]
    if (ov) {
      if (ov.capa != null) { v.chg.capaDir = ov.capa < v.capa ? 'down' : 'up'; v.capa = ov.capa; v.chg.capa = '시나리오' }
      if (ov.capaMode) v.capaMode = ov.capaMode // 제한/무한 전환도 운영 단위로 가능(기본 운영과 동일 편집)
      if (ov.start) { v.start = ov.start; v.chg.start = '시나리오' }
      if (ov.endAt) { v.endAt = ov.endAt; v.chg.endAt = '시나리오' }
      if (ov.releases) { v.releases = ov.releases; v.chg.releases = '시나리오' }
      // 휴무 요일 오버라이드 = 전체 교체 — 운영 기간엔 기본 휴무를 풀 수도(예: 성수기 일요일 운영), 더할 수도 있다
      if (ov.restDays) v.off = ov.restDays.includes(d.getDay())
    }
    // 운영(시나리오) 요일 예외 카드 — 기본의 dowExc 와 동일 위계 규칙(카드 값이 운영 기본값을 덮음)
    const sCard = (state.scenDow[st.id]?.[ci] ?? []).find((c) => c.days.includes(d.getDay()))
    if (sCard) {
      if (sCard.capa != null) { v.chg.capaDir = sCard.capa < v.capa ? 'down' : 'up'; v.capa = sCard.capa; v.chg.capa = '시나리오' }
      if (sCard.start) { v.start = sCard.start; v.chg.start = '시나리오' }
      if (sCard.endAt) { v.endAt = sCard.endAt; v.chg.endAt = '시나리오' }
      if (sCard.releases) { v.releases = sCard.releases; v.chg.releases = '시나리오' }
    }
  }
  // 당일 예외의 **제한/무한만** 여기서 먼저 반영한다. 아래 가동률(util·orders)이 capaMode 를 전제로
  //  계산되기 때문이다 — 케파 숫자처럼 맨 뒤에서 덮으면 게이지가 옛 모드로 계산되어 값과 표시가 어긋난다.
  //  나머지 예외 값은 종전대로 최상위 우선으로 맨 아래에서 덮는다.
  const ex = state.todayExc[excKey(ci, d)]
  if (ex?.capaMode) v.capaMode = ex.capaMode
  const isToday = sameDay(d, today)
  const isPast = !isToday && d < today
  if (isToday) v.util = Math.round(55 + seed(ci + 3) * 40)
  if (isPast) {
    let rate = 0.45 + seed(ci * 5 + d.getDate()) * 0.5 // 45~95%
    if (v.capaMode === 'unlimited' && seed(ci * 3 + d.getDate()) > 0.6) rate = 1.05 + seed(ci + d.getDate()) * 0.25 // 무한: 가끔 초과 처리
    v.orders = Math.round((v.capa * rate) / 100) * 100
    v.orderPct = Math.round((v.orders / v.capa) * 100)
  }
  if (isToday && v.capaMode === 'unlimited') v.util = Math.round(108 + seed(ci) * 12) // 무한: 오늘 초과 가동 데모
  // 당일 예외 — 최상위 우선(capaMode 는 위에서 이미 반영)
  if (ex) {
    v.exc = ex
    if (ex.off) v.off = true
    if (ex.capa != null) { v.chg.capaDir = ex.capa < v.capa ? 'down' : 'up'; v.capa = ex.capa; v.chg.capa = '당일예외' }
    if (ex.start) { v.start = ex.start; v.chg.start = '당일예외' }
    if (ex.endAt) { v.endAt = ex.endAt; v.chg.endAt = '당일예외' }
    if (ex.releases) { v.releases = ex.releases; v.chg.releases = '당일예외' }
  }
  // 오늘도 지시량 노출(LUA) — 라이브 게이지(util)에서 유도. 예외로 케파가 바뀐 뒤 계산해 값·바·% 정합 유지.
  if (isToday && !v.off && v.util != null) {
    v.orders = Math.round((v.capa * v.util) / 100 / 100) * 100
    v.orderPct = Math.round((v.orders / v.capa) * 100)
  }
  return v
}
// 예외 등록 비교 기준: 현재 적용값(시나리오까지 반영, 예외 제외)
export function appliedVals(state: DispatchState, today: Date, d: Date, ci: number): CellVals {
  const noExc: DispatchState = { ...state, todayExc: {} }
  return dayVals(noExc, today, d, ci)
}

// ── 운영 설정 모달 계약 타입 — 구 DS DispatchSettingsModal.tsx 가 갖던 것(모달은 컨덕터 트리로 분해, 타입만 여기로 2026-09-10).
/** 시나리오(운영)의 센터별 오버라이드 — 기본 운영값 중 일부만 덮는다. */
export type ScenOverride = Partial<Pick<CenterVals, 'capa' | 'capaMode' | 'start' | 'endAt' | 'releases' | 'restDays'>>
/** 운영 저장 payload — 신규(id null)/수정. 값·요일예외·순위·대기 오버라이드를 센터/시간대별로. */
export interface ScenSavePayload { id: string | null; name: string; from: string; to: string; scenVals: Record<number, ScenOverride>; scenDow: Record<number, DowCard[]>; scenPrio: Record<number, number[]>; scenWait: Record<number, number> }
